
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/termsOfService",
      function () {
        return require("private-next-pages/termsOfService.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/termsOfService"])
      });
    }
  